import { createAsyncThunk } from "@reduxjs/toolkit";

import API, { showNetworkErrorToast } from "Utils/api";

export const fetchGetVdaActionDefinitions = createAsyncThunk(
  "vdaActionDefinitions/fetchGetVdaActionDefinitions",
  async () => {
    try {
      const response = await API.get("vda_action_definitions/");
      return response.data.results;
    } catch (error) {
      showNetworkErrorToast(error);
      return Promise.reject();
    }
  }
);
